import { useRead, ReadState, isVideos } from "@/components/LoadingStates";


import { useState } from "react";
import { useParams, Link } from "react-router-dom";

import VideoCard from "@/components/VideoCard";
import PlatformBadge from "@/components/PlatformBadge";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { classNames } from "@/lib/format";

export default function WatchlistDetail() {
  const { id } = useParams();
  const detailRead = useRead(`/watchlists/${id}/videos`, d => d && d.watchlist && typeof d.watchlist.name === "string" && isVideos(d.videos));
  const data = detailRead.data;
  const [showOutliers, setShowOutliers] = useState(false);

  if (detailRead.status !== "success") return <div data-testid="watchlist-detail-page"><Link to="/watchlists" className="text-sm text-primary">Retour à la liste</Link><ReadState read={detailRead} scope="watchlist-detail" /></div>;
  const { watchlist, videos } = data;
  const shown = showOutliers ? videos.filter((v) => v.is_outlier) : videos;

  return (
    <div className="space-y-6" data-testid="watchlist-detail-page">
      <Link to="/watchlists" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1">
        <ArrowLeft className="h-4 w-4" /> Back to watchlists
      </Link>

      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{watchlist.name}</h1>
        <p className="text-muted-foreground text-sm mt-1">{watchlist.description || "No description"}</p>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={() => setShowOutliers(false)}
          className={classNames("px-3 py-1.5 text-xs rounded-md font-medium", !showOutliers ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:text-foreground")}
          data-testid="wl-filter-all"
        >
          All videos ({videos.length})
        </button>
        <button
          onClick={() => setShowOutliers(true)}
          className={classNames("px-3 py-1.5 text-xs rounded-md font-medium", showOutliers ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:text-foreground")}
          data-testid="wl-filter-outliers"
        >
          Outliers only ({videos.filter((v) => v.is_outlier).length})
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
<ReadState read={detailRead} scope="watchlist-detail" empty={!shown.length} filtered={showOutliers && !!videos.length} title={showOutliers && videos.length ? "Aucun outlier dans cette watchlist" : "Aucune vidéo disponible dans cette watchlist"} primaryCta={showOutliers && videos.length ? { label: "Afficher toutes les vidéos", onClick: () => setShowOutliers(false) } : { label: "Consulter les créateurs", to: "/creators" }}>
        {shown.map((v) => <VideoCard key={v.id} video={v} />)}
        </ReadState>
      </div>
    </div>
  );
}
